import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Header({ toggleDrawer, activePage, isDrawerOpen }) {
  const { currentUser, logout } = useAuth();
  const [showLogoutMenu, setShowLogoutMenu] = useState(false);
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    navigate('/');
  };

  const handleLogout = async () => {
    try {
      await logout();
      setShowLogoutMenu(false);
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleLogoutMenu = () => {
    setShowLogoutMenu(!showLogoutMenu);
  };

  return (
    <header className="mdc-top-app-bar">
      <div className="mdc-top-app-bar__row">
        <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-start logo-container">
          {/* Animated Hamburger Button */}
          <button 
            id="toggleMenu"
            onClick={toggleDrawer}
            className={`hamburger-button ${isDrawerOpen ? 'active' : ''}`}
            aria-label="Toggle navigation menu"
          >
            <span></span>
          </button>

          {/* Logo - clickable to navigate home */}
          <img
            src="/mailvotes-logo.png"
            alt="MailVotes Logo"
            className="logo clickable-logo"
            onClick={handleHomeNavigation}
            style={{ cursor: 'pointer', height: '36px', width: 'auto' }}
          />

          <span
            className="mdc-top-app-bar__title clickable-title"
            onClick={handleHomeNavigation}
            style={{ cursor: 'pointer' }}
          >
            MailVotes
          </span>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,.42)', marginLeft: '8px', alignSelf: 'center' }}>
            by Doornoc
          </span>
        </section>
        
        <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
          <nav>
            <Link
              to="/"
              id="homeButton"
              className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'mainContent' ? 'active-nav-link' : ''}`}
            >
              Home
            </Link>
            <Link
              to="/voters"
              id="voterButton"
              className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'voterContent' ? 'active-nav-link' : ''}`}
            >
              Voters
            </Link>
            <Link
              to="/postcards"
              id="postcardsButton"
              className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'postcardsContent' ? 'active-nav-link' : ''}`}
            >
              Postcards
            </Link>
            <Link
              to="/about"
              id="aboutButton"
              className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'aboutContent' ? 'active-nav-link' : ''}`}
            >
              About
            </Link>
            <Link
              to="/mailing-lists"
              id="mailingListsButton"
              className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'mailingListsContent' ? 'active-nav-link' : ''}`}
            >
              Mailing Lists
            </Link>

            {/* Switch to DoorNoc Button */}
            <a
              href="https://app.doornoc.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '7px 14px',
                marginRight: '4px',
                marginLeft: '8px',
                backgroundColor: '#4CAF50',
                color: 'white',
                borderRadius: '999px',
                fontSize: '12px',
                fontWeight: '600',
                textDecoration: 'none',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#45a049'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4CAF50'}
            >
              <span>Switch to DoorNoc</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>

            {/* User Menu */}
            {currentUser ? (
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  onClick={toggleLogoutMenu}
                  className="mdc-top-app-bar__action-item mdc-button"
                >
                  {currentUser.displayName || currentUser.email}
                </button>
                {showLogoutMenu && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    minWidth: '140px',
                    zIndex: 1000
                  }}>
                    {(() => {
                      const menuItemStyle = {
                        width: '100%',
                        padding: '10px 12px',
                        border: 'none',
                        backgroundColor: 'transparent',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                        fontFamily: 'inherit'
                      };
                      
                      const handleMouseOver = (e) => e.target.style.backgroundColor = '#f5f5f5';
                      const handleMouseOut = (e) => e.target.style.backgroundColor = 'transparent';
                      
                      return (
                        <>
                          <button
                            onClick={() => {
                              setShowLogoutMenu(false);
                              navigate('/profile');
                            }}
                            style={{
                              ...menuItemStyle,
                              borderRadius: '4px 4px 0 0'
                            }}
                            onMouseOver={handleMouseOver}
                            onMouseOut={handleMouseOut}
                          >
                            Profile
                          </button>
                          <button
                            onClick={handleLogout}
                            style={{
                              ...menuItemStyle,
                              borderRadius: '0 0 4px 4px',
                              borderTop: '1px solid #eee'
                            }}
                            onMouseOver={handleMouseOver}
                            onMouseOut={handleMouseOut}
                          >
                            Logout
                          </button>
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                id="loginButton"
                className={`mdc-top-app-bar__action-item mdc-button ${activePage === 'loginContent' ? 'active-nav-link' : ''}`}
              >
                Login
              </Link>
            )}
          </nav>
        </section>
      </div>
    </header>
  );
}

export default Header;
